import { getAllElementsInColsInLayoutComponent } from "./index"

/*
* handleCurComponentAppId 是否处理当前组件的的appid(区分当前组件内嵌套组件的appid)
* */
// 复制等情况时 处理子组件的appid
export function handleChildAppid(rectAttr,containerId,rectIds,handleCurComponentAppId, replacePageId){
  const _this=this
  const lowerShape = rectAttr.shape?.toLowerCase()
  //  说明此时是基础组件
  if(rectAttr?.options?.appId && handleCurComponentAppId){
    _this.$saveModule(
      {
        container_id: containerId,
        rect_id: rectAttr.rect_id
      },
      "31CB73E03E24BBFF",
      "临时",
      false,
      rectAttr.options.appId,
      false,
      true,
      replacePageId
    )
  }
  if(lowerShape && !lowerShape.includes("layout") && lowerShape !== 'swipercomponent'){
    return
  }
  // 自由布局
  if(rectAttr.shape === 'layoutComponent' || rectAttr.shape === 'emptyLayoutComponent' || rectAttr.shape === "layoutComponentBigScreen"){
    handleLayoutChildAppId(rectAttr.options.rows,{
      container_id: containerId,
      rect_id:rectAttr.rect_id
    })
  }
  // 轮播
  if(rectAttr.shape === 'swiperComponent'){
    handleSwiperChildAppId(rectAttr.options.content, {
      container_id: containerId,
      rect_id:rectAttr.rect_id
    })
  }
  // 自动布局
  if(rectAttr.shape === 'cxAutoLayout'){
    handleAutoLayoutChildAppId(rectAttr.options.elementOptions,{
      container_id: containerId,
      rect_id:rectAttr.rect_id
    })
  }
  // 同步单元格
  if(!rectAttr.shape && rectAttr.content.cols && rectIds){
      handleColChildAppId([rectAttr.content],rectIds)
  }
  // 处理自由布局子组件的appId
  function handleColChildAppId(rows,ids){
    const allElementInLayout = getAllElementsInColsInLayoutComponent(rows)
    for (let uid in allElementInLayout) {
      const col = allElementInLayout[uid]
      col.elementOptions &&
      Array.isArray(col.elementOptions) &&
      col.elementOptions.forEach(elementInLayout => {
        if(elementInLayout.innerElement === 'cxAutoLayout'){
          handleBaseComponentAppId (elementInLayout.elementOptions,{
            ...ids,
            uid:uid
          })
        }
        if (elementInLayout.appId) {
          const { elementInLayoutId } = elementInLayout
          _this.$saveModule(
            {
              ...ids,
              uid:uid,
              elementInLayoutId:elementInLayoutId },
            "31CB73E03E24BBFF",
            "临时",
            false,
            elementInLayout.appId,
            false,
            true,
            replacePageId
          )
        }
      })
    }
  }
  // 处理自由布局子组件的appId
  function handleLayoutChildAppId(rows,ids){
    const allElementInLayout = getAllElementsInColsInLayoutComponent(rows)
    for (let uid in allElementInLayout) {
      const col = allElementInLayout[uid]
      col.elementOptions &&
      Array.isArray(col.elementOptions) &&
      col.elementOptions.forEach(elementInLayout => {
        if(elementInLayout.innerElement === 'cxAutoLayout'){
          handleBaseComponentAppId (elementInLayout.elementOptions,{
            ...ids,
            uid:uid
          })
        }
        if (elementInLayout.appId) {
          const { elementInLayoutId } = elementInLayout
          _this.$saveModule(
            {
              ...ids,
              uid:uid,
              elementInLayoutId:elementInLayoutId },
            "31CB73E03E24BBFF",
            "临时",
            false,
            elementInLayout.appId,
            false,
            true,
            replacePageId
          )
        }
      })
    }
  }
// 处理轮播组件子组件的appId
  function handleSwiperChildAppId(allElementInLayout,ids){
    allElementInLayout && Array.isArray(allElementInLayout) &&
    allElementInLayout.forEach(elementInLayout =>{
      const {swiperContent_id} = elementInLayout
      elementInLayout.elementOptions?.forEach(element=>{
        if(elementInLayout.innerElement === 'cxAutoLayout'){
          handleBaseComponentAppId (element.elementOptions,{
            ...ids,
            swiperContent_id: swiperContent_id
          })
        }
        if(element.appId){
          _this.$saveModule(
            { ...ids,swiperContent_id: swiperContent_id, elementInSwiperId:element.elementInSwiperId },
            "31CB73E03E24BBFF",
            "临时",
            false,
            element.appId,
            false,
            true,
            replacePageId
          )
        }
      })
    })
  }
// 处理自动布局内的子组件的appId
  function handleAutoLayoutChildAppId(elementOptions,ids){
    elementOptions.forEach(element=>{
      if(element.innerElement === "cxAutoLayout"){
        handleAutoLayoutChildAppId(element.elementOptions,ids)
      }else{
        if(element.appId) {
          _this.$saveModule(
            { ...ids, path: element.path, elementInAutoLayoutId: element.elementInAutoLayoutId },
            "31CB73E03E24BBFF",
            "临时",
            false,
            element.appId,
            false,
            true,
            replacePageId
          )
        }
          if(element.innerElement === 'emptyLayoutComponent' || element.innerElement === 'layoutComponent'){
            handleLayoutChildAppId(element.rows,{
              ...ids,
              elementInAutoLayoutId:element.elementInAutoLayoutId,
              path:element.path
            })
          }else if(element.innerElement === 'swiperComponent'){
            handleSwiperChildAppId(element.content,{
              ...ids,
              elementInAutoLayoutId:element.elementInAutoLayoutId,
              path:element.path
            })
          }
      }
    })
  }
// 处理基础组件的appid
  function handleBaseComponentAppId(elementOptions,ids){
    elementOptions.forEach(element=>{
      if(element.appId) {
        _this.$saveModule(
          { ...ids,
            elementInLayoutId: element.elementInLayoutId,
            elementInAutoLayoutId:element.elementInAutoLayoutId,
            path:element.path,
            elementInSwiperId:element.elementInSwiperId},
          "31CB73E03E24BBFF",
          "临时",
          false,
          element.appId,
          false,
          true,
          replacePageId
        )
      }
    })
  }
}
